import { useEffect, useRef, useState } from "react";
import {Button, Col, Row, Tabs} from "antd";
import { useSetState } from "ahooks";
import styles from "./index.module.less";
import classNames from "classnames";
import DataModal from "./dialog/dataModal.tsx";
import { getAppointmentData} from "@/services/saleOpServices.ts";
import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'
import { KeepAlive} from 'react-activation';
import {clueStatusList, tabItems} from "@/pages/salesWorkbench/workbenchList/tabEnum.tsx";
import EmergencyTask from "@/pages/salesWorkbench/workbenchList/components/EmergencyTask";

const SalesWorkbenchList = () => {
    const { activeTabKey, setActiveTabKey } = useGlobalStore(
        useShallow((state: any) => ({
            activeTabKey: state.activeTabKey,
            setActiveTabKey: state.setActiveTabKey,
        }))
    )
    const listRef = useRef<any>()
    const [isVisible, setIsVisible] = useState(false);
    const [activeKey, setActiveKey] = useState('');
    const [state, setState] = useSetState<any>({
        open: false,
        record: {},
        peopleNumber: [
            {
                number: 0,
                title: '今日预约到店客户',
                value: 'todayAppointment'
            },
            {
                number: 0,
                title: '今日已到店客户',
                value: 'todayArrived'
            },
            {
                number: 0,
                title: '明日预约到店客户',
                value: 'tomorrowAppointment'
            },
        ],
        taskList: []
    })

    useEffect(() => {
        featchAppointmentData();
    }, []);
    const featchAppointmentData = async () => {
        const res: any = await getAppointmentData();
        const peopleNumber = state.peopleNumber;
        peopleNumber[0].number = res['todayAppointment'];
        peopleNumber[1].number = res['todayArrived'];
        peopleNumber[2].number = res['tomorrowAppointment'];
        setState({ peopleNumber })
    }

    const onCustomerClick = (activeKey) => {
        setActiveKey(activeKey)
        setIsVisible(true)
    }
    const handleSelect = (item) => {
        setActiveTabKey(item.value)
    }

    return (
        <div className={styles.salesWorkbenchBox}>
            <div style={{ overflowX: 'hidden' }}>
                <Row gutter={10} align="stretch" style={{ overflow: 'hidden' }}>
                    <Col flex={2}>
                        <div className={styles.topIconBox}>
                            {state.peopleNumber?.map?.((d: any, i) => (
                                <div key={`item_${i}`} className={styles.infoBox} onClick={() => onCustomerClick(d.value)}>
                                    <div className={styles.iconBox}></div>
                                    <div className={styles.descBox}>
                                        <div className={styles.textStrong}>{d.number}<span>人</span></div>
                                        <div className={styles.textTitle}>{d.title}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col flex={3}>
                        <div className={styles.importInfoBox} >
                            <EmergencyTask reload={listRef.current?.reload}/>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className={styles.cardBox}>
                <Tabs activeKey={activeTabKey} type={"card"} rootClassName={styles.tabBox}
                      more={{ icon: <Button type={"link"}>更多</Button>, popupRender: (menus) =><div>{menus}</div>}} >
                    {tabItems.map((d, i) => {
                            const isSelected = activeTabKey === d.value
                            return <Tabs.TabPane key={d.value} tab={<div
                                key={`order_data_${i}`}
                                className={classNames(styles.itemTitle, {[styles.selected]: isSelected})}
                                onClick={() => handleSelect(d)}
                            >{d.title}</div>}>
                            </Tabs.TabPane>
                        }
                    )}
                </Tabs>
            </div>
                {/* 商机运营 */}
            {
                Object.keys(clueStatusList)?.map(key =>
                    {return (key && key === activeTabKey) ? (
                        <div>
                            <KeepAlive name={location.pathname + '/' + activeTabKey}>{ clueStatusList[activeTabKey].component }</KeepAlive>
                        </div>
                    ): <div></div>}
                )
            }
            {
                isVisible ?
                    <DataModal
                        open={isVisible}
                        activeKey={activeKey}
                        onClose={() => {
                            setIsVisible(false)
                        }}
                        reload={() => listRef.current.reload()}
                    /> : null
            }
        </div>
    )
}

export default function NewSalesWorkbenchList() {
    return (
        <SalesWorkbenchList />
    )
}
